import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@modusign/design-system';

import useAuthorizeContractSetupStartButtonErrorMessage from '@app/containers/GlobalNavigationBar/useAuthorizeContractSetupStartButtonErrorMessage';
import { useSubscription } from '@app/features/subscription/hooks/subscription';
import isTrialPlan from '@app/features/subscription/libs/isTrialPlan';
import useResponsiveValue from '@app/hooks/useResponsiveValue';

import GNBPrimaryButton from '../GNBPrimaryButton';

interface ContractSetupStartButtonProps {
  onClick: () => void;
}

function ContractSetupStartButton({ onClick }: ContractSetupStartButtonProps) {
  const guideMessage = useAuthorizeContractSetupStartButtonErrorMessage();
  const { data: subscription } = useSubscription();

  const isDesktopWidth = useResponsiveValue([false, false, true]);

  return (
    <Tooltip
      content={guideMessage}
      disabled={!guideMessage}
      gutter={24}
      placement={isDesktopWidth ? 'right' : 'top'}
    >
      <GNBPrimaryButton disabled={!!guideMessage} onClick={onClick}>
        <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: '6px' }} />
        서명 요청{isTrialPlan(subscription?.plan?.id) && ' (Trial)'}
      </GNBPrimaryButton>
    </Tooltip>
  );
}

export default ContractSetupStartButton;
